import React from "react";
import {REFERRAL_LINK} from "../../default_informations/referral_link";

function HeaderButtons() {
    const referralLink = REFERRAL_LINK;

    return (
        <div className="gg-header__btns col-auto">
            <a href={referralLink}
               className="r-form__enter"
               rel="nofollow noopener noreferrer"
               target="_blank">Логин</a>
            <a href={referralLink}
               className="r-form__reg"
               rel="nofollow noopener noreferrer"
               target="_blank">Регистрация</a>
        </div>
    )
}

export default HeaderButtons;